<template>
    <div class="pt-10 pb-20 bg-background3 large:pt-[4.25rem] large:pb-[4.8125rem]">
        <div class="container">
            <div class="wrap">
                <router-view v-slot="{Component, route}">
                    <component :is="Component" :key="route.path" />
                </router-view>
            </div>
        </div>
    </div>
</template>

<script>
    export default {};
</script>
